import React from 'react';
import { bonuses } from '../data/bonuses';
import { SunArcs } from './SunArcs';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="arcs-dark w-full bg-night-deep" data-id="element-53" data-mp="piy2uloqjvk1">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-20" data-id="element-54" data-mp="aua4y8rf39qx">
        <div className="text-center" data-id="element-55" data-mp="ftmsywu0ymv3">
          <p className="eyebrow text-saffron" data-id="element-56" data-mp="fslh4q56pwcb">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-sand sm:text-5xl" data-id="element-57" data-mp="1tc1brkw548v">
            Five instant-use <span className="text-coral" data-id="element-58" data-mp="3o24um0nmdvts">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-sand/80" data-id="element-59" data-mp="3o3y6bud3b68n">
            The volumes give you the classes. These five clear the usual
            blockers — where to start, which session, nervous students,
            last-minute changes, what if someone falls — so you can teach from
            it this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-60" data-mp="3idemq7nsy65x">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl border border-night-line bg-night ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-61" data-mp="3deaepkcm6eh6" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} loading="lazy" className="aspect-square w-full border-b border-night-line object-cover" data-id="element-62" data-mp="2ugha8dmcdwho" /> :
          // Portada de respaldo con la identidad del producto
          <div className="arcs-light relative flex aspect-[4/3] w-full flex-col justify-between overflow-hidden border-b border-night-line bg-sand p-5" data-id="element-63" data-mp="nozzcsh3ec9n">
                  <SunArcs className="pointer-events-none absolute -bottom-12 -right-10 h-44 w-44 text-coral/30" data-id="element-64" data-mp="3ciwryrwu9nk7" />
                  <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full font-display text-xl text-night ring-4 ring-sand ${bonus.accent}`} data-id="element-65" data-mp="3hhr97pf5r427">
                    {bonus.number}
                  </span>
                  <div className="relative" data-id="element-66" data-mp="3qglb9vb9cmn5">
                    <div className="mb-2 flex gap-1" aria-hidden="true" data-id="element-67" data-mp="2tt7zd5ggmj80">
                      <span className="h-1.5 w-7 rounded-full bg-ground" data-id="element-68" data-mp="2xu0c48ojj691" />
                      <span className="h-1.5 w-7 rounded-full bg-lift" data-id="element-69" data-mp="2xrxmvqv7ph5d" />
                      <span className="h-1.5 w-7 rounded-full bg-fly" data-id="element-70" data-mp="32sblyjeu5gr9" />
                    </div>
                    <span className="text-[10px] font-extrabold uppercase tracking-[2px] text-night-soft" data-id="element-71" data-mp="37klg6bmzh2zc">
                      Acro Yoga Class Ready · Bonus {bonus.number}
                    </span>
                    <p className="mt-1 font-display text-2xl leading-tight text-night" data-id="element-72" data-mp="2f27qizbswnbc">
                      {bonus.title}
                    </p>
                  </div>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-73" data-mp="22lg5v91t1xb4">
                <div className="flex flex-wrap items-center gap-2" data-id="element-74" data-mp="1xlk29ax0s7w3">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-sand/65" data-id="element-75" data-mp="1xnwuqi0em0ne">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-coral px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-night" data-id="element-76" data-mp="1om70l4f50nlx">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-lg leading-snug text-sand" data-id="element-77" data-mp="1evvnar9kd22d">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-sand/75" data-id="element-78" data-mp="19ueqp7y441rl">
                  {bonus.body}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}